import { render, staticRenderFns } from "./BloodCompatibility.vue?vue&type=template&id=67c67e9d&scoped=true"
import script from "./BloodCompatibility.vue?vue&type=script&lang=js"
export * from "./BloodCompatibility.vue?vue&type=script&lang=js"
import style0 from "./BloodCompatibility.vue?vue&type=style&index=0&id=67c67e9d&prod&scoped=true&lang=css"
import style1 from "./BloodCompatibility.vue?vue&type=style&index=1&id=67c67e9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c67e9d",
  null
  
)

export default component.exports